export default __webpack_public_path__ + "static/media/fc-icon-28-pink.1a451845.svg";